import logoControl from './logoControl'

export const LogoControl = logoControl
